import React, { useEffect, useState } from "react";
import "./Accomplishments.css";
import LoadingSpinner from "../Shared/LoadingSpinner/LoadingSpinner";
import Sidebar from "../Shared/Sidebar/Sidebar";
import cert1 from "../../assets/certificates/cert1.PNG";
import cert2 from "../../assets/certificates/cert2.PNG";
import cert3 from "../../assets/certificates/udemy1.jpg";
import cert4 from "../../assets/certificates/cert4.PNG";
import cert5 from "../../assets/certificates/cert5.PNG";
import cert6 from "../../assets/certificates/cert6.PNG";
import cert18 from "../../assets/certificates/cert7.PNG";
import cert7 from "../../assets/certificates/coursera1.PNG";
import cert8 from "../../assets/certificates/coursera2.PNG";
import cert9 from "../../assets/certificates/coursera3.PNG";
import cert10 from "../../assets/certificates/coursera4.PNG";
import cert11 from "../../assets/certificates/coursera5.PNG";
import cert12 from "../../assets/certificates/coursera6.PNG";
import cert13 from "../../assets/certificates/coursera7.PNG";
import cert14 from "../../assets/certificates/coursera8.PNG";
import cert15 from "../../assets/certificates/coursera9.PNG";
import cert16 from "../../assets/certificates/coursera10.PNG";
import cert17 from "../../assets/certificates/coursera11.PNG";
import lws1 from "../../assets/certificates/LWS-Certificate.jpg";
import lws2 from "../../assets/certificates/LWS-Excellence-Certificate.jpg";
import lws3 from "../../assets/certificates/LWS-Recommendation-Letter.jpg";
import codeman from "../../assets/certificates/codemanbd.png";
import Aos from "aos";

const Accomplishments = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);

    Aos.init({
      duration: 600,
      offset: 30,
    });
  }, []);

  return (
    <section>
      <Sidebar></Sidebar>

      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <div className="lg:pl-[220px] ">
          <div className="px-4 lg:px-20 w-full min-h-screen">
            <div className="py-6 lg:py-12">
              <h1 className="mb-6 animate__animated animate__fadeInDown lg:mb-12 text-center title-text mt-12 lg:mt-5 text-4xl lg:text-[55px] font-bold text-[#04BF00] tracking-[.07em]">
                Accomplishments
              </h1>
              <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 lg:gap-4">
                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2  lg:space-y-5 form-text">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          Think in a Redux way <br />{" "}
                          <span className="text-[10px] lg:text-sm font-medium">
                            (Course Certificate)
                          </span>
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://learnwithsumit.com/certificates/verify/LWSCTXN-77QTNE9D"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={lws1}
                      className="w-full  md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2  lg:space-y-5 form-text">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          Think in a Redux way <br />{" "}
                          <span className="text-[10px] lg:text-sm font-medium">
                            (Achieved Top 6th Position)
                          </span>
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://learnwithsumit.com/certificates/verify/LWSCTXN-77QTNE9D"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={lws2}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5 form-text">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          Think in a Redux way <br />{" "}
                          <span className="text-[10px] lg:text-sm font-medium">
                            (Recommendation Letter)
                          </span>
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://learnwithsumit.com/certificates/verify/LWSCTXN-77QTNE9D"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-200 flex justify-center items-center h-full">
                    <img
                      src={lws3}
                      className="h-[120px] md:h-[170px] shadow-lg"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2  lg:space-y-5 form-text">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          Programming Hero <br />{" "}
                          <span className="text-[10px] lg:text-sm font-medium">
                            (Complete Web Development)
                          </span>
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/1kJ2Dm_d9PSfxz38BTgPGiJ9kVQYg_p-r/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert1}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2  lg:space-y-5 form-text">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          CodemanBD <br />{" "}
                          <span className="text-[10px] lg:text-sm font-medium">
                            (WordPress & Ecommerce)
                          </span>
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/1Ju3anvGHs1hSTimsul7Xv6zDahNOPxY5/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={codeman}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          IEEE AIUB <br />{" "}
                          <span className="text-[10px] lg:text-sm font-medium">
                            (Frontend Workshop)
                          </span>
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/14m7N0p5SJ1AdvVaZ80vDddLhWnPPUPRU/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert2}
                      className="w-full h-[100%] md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          Udemy
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://www.coursera.org/account/accomplishments/verify/6L3HKFQJB84Z"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert3}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          CISCO
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/1KacoSQWrpLyQ5enZvDWWrhAgRYptEpDW/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert4}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          ICT DIVISION
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/1-xISTJmpKY2ebfO-aj29bXJ8ebjwTWIo/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert5}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          ICT DIVISION
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/16Al_hucym1aMrE2g6QiZVCh24_Pex-NQ/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert6}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          SR DREAM IT
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://drive.google.com/file/d/16U4aZ4brPBCs2UqZQLLjdGXBUpdCalZa/view?usp=sharing"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert18}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://www.coursera.org/account/accomplishments/certificate/R5FF5V2GBP4X"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert7}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/88f01fc06374ab2520e865f367d070b5"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert8}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://www.coursera.org/account/accomplishments/certificate/XY4AEA7HNWDZ"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert9}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://www.coursera.org/account/accomplishments/certificate/GEGKH2FMYY2A"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert10}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/5c72000ebb428177cf862980724ed9c9"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert11}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/8bafda0010d9741db104e6697a9ff3bb"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert12}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/5c58ac84de4b7dd79bce53db9b4796f9"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert13}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/8733042368408d3f9623d2d0d0c54f30"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert14}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/290d05cce7d8a69467bd3579a802690c"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert15}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://www.coursera.org/account/accomplishments/verify/6L3HKFQJB84Z"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert16}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  data-aos="zoom-in"
                  className="relative transition-all duration-400 card2 overflow-hidden"
                >
                  <div className="bg-[#07101f] opacity-100 w-full h-full popup-info2">
                    <div className="flex justify-center items-center h-full">
                      <div className="space-y-2 lg:space-y-5">
                        <h4 className="text-center text-sm lg:text-xl font-semibold">
                          COURSERA
                        </h4>
                        <div className="text-center">
                          <a
                            href="https://coursera.org/share/223cbe0a79bccd7cec4b1e1c6cd602a0"
                            className="form-text text-[11px] lg:text-sm px-4 lg:px-6 py-2 bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                            rel={"noreferrer"}
                            target={"_blank"}
                          >
                            View Credential
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full">
                    <img
                      src={cert17}
                      className="w-full h-full md:h-[170px] lg:h-[200px]"
                      alt=""
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Accomplishments;
